module.exports = __webpack_public_path__ + "img/subject.83520ea5.svg";